import React, { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import toast from 'react-hot-toast';
import JoditEditor from "jodit-react";
import { postDispatchTemplateDetails, GetDispatchDetailsByTemplateId, getDefaultDispatchTemplateDetails } from '../store/actions/dispatchOrderDetailsActions'

const config = {
    readonly: false, // all options from https://xdsoft.net/jodit/doc/
    height: '500px'
}
class DispatchTemplate extends Component {
    constructor(props) {
        super(props)
        console.log(props, "FFFF")
        this.state = {
            BodyText1: "",
            BodyText2: "",
            BodyText2_1: "",
            BodyText2_2: "",
            BodyText2_3: "",
            BodyText2_4: "",
            BodyText2_5: "",
            BodyText2_6: "",
            BodyText2_7: "",
            BodyText3: "",
            BodyText4: "",
            BodyText5: "",
            BodyText6: "",
            BodyText7: "",
            BodyText7_1: "",
            BodyText7_2: "",
            BodyText7_3: "",
            templateData: "",
            defaultTemplateData: "",
            TemplateId: this.props.location.state.TemplateId,
            TemplateName: props.location.state.TemplateName ? props.location.state.TemplateName : "",
            finalData: {}
        }
    }
    dataSync = async () => {
        let finalData = {}
        let templateData = ""
        let defaultTemplateData = ""
        let TemplateName = this.props.location.state.TemplateName
        await this.props.getDefaultDispatchTemplateDetails()
        await this.props.GetDispatchDetailsByTemplateId(this.props.location.state.TemplateId)
        let formData = await this.props.dispatchOrderDetailsReducer.getDispatchTemplateDetails.recordset
        formData.filter(data => data.TemplateId == this.state.TemplateId)
        console.log(this.props.dispatchOrderDetailsReducer.getDispatchTemplateDetails.recordset, "pppopopop")
        if (formData.length > 0) {
            templateData = formData[0].templateData
        }
        if (this.props.dispatchOrderDetailsReducer.defaultDispatchTemplateDetails && this.props.dispatchOrderDetailsReducer.defaultDispatchTemplateDetails.length > 0) {
            defaultTemplateData = this.props.dispatchOrderDetailsReducer.defaultDispatchTemplateDetails[0].templateData
        }
        await this.setState({ TemplateName, templateData, defaultTemplateData })
    }
    componentDidMount() {
        this.dataSync()
    }
    blurTemplateData = (templateData) => {
        this.setState({ templateData: templateData })
    }
    handleTemplateData = (templateData) => {
        this.setState({ templateData: templateData })
    }
    saveData = async () => {
        var templateData = this.state.templateData
        if (this.state.templateData == '' || this.state.templateData == null) {
            templateData = this.state.defaultTemplateData
            // await this.props.postDispatchTemplateDetails(input)
        }
        let input = {
            TemplateName: this.state.TemplateName,
            templateData: templateData,
            TemplateId: this.props.location.state.TemplateId
        }
        await this.props.postDispatchTemplateDetails(input)

        await this.dataSync()
        await toast.success(`Successfully Saved`, {
            duration: 3000
        });
    }
    render() {
        return (
            <div className="container" style={{ marginBottom: '3%' }}>
                <div className="w-100 mx-auto shadow p-5" style={{ marginTop: "1%" }}>
                    <h2 className="text-center mb-4 pb-2">DISPATCH CLEARANCE TEMPLATE</h2>
                    <div className="row">
                        <div className="col-md-5" style={{ marginLeft: "35%" }}>
                            <h4>{this.state.TemplateName}</h4>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-12">
                            <b for="firstname">Template :</b>
                            <JoditEditor value={this.state.templateData ? this.state.templateData : this.state.defaultTemplateData} config={config} tabIndex={1} // tabIndex of textarea
                                onBlur={newContent => this.blurTemplateData(newContent)}
                                onChange={newContent => this.handleTemplateData(newContent)}
                            />
                        </div>
                        <div className='form-group col-12'>
                            <button className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right" onClick={() => this.saveData()} type="submit">Save</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => ({ dispatchOrderDetailsReducer: state.dispatchOrderDetailsReducer })
export default connect(mapStateToProps, { postDispatchTemplateDetails, GetDispatchDetailsByTemplateId, getDefaultDispatchTemplateDetails })(DispatchTemplate)
